export interface Recipient {
  cell_num: string;
  is_received: boolean;
}

export const initialRecipient: Recipient = {
  cell_num: '',
  is_received: false,
};
